import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import { Loading, Icon, Tabs, Tab, DropdownMenu, DropdownItem, RadioGroup, Radio,CellGroup, Row,Col,Cell, Calendar, Toast, Divider, ActionSheet, Dialog,  Button, DatetimePicker, Popup, PullRefresh, Checkbox,Sticky } from 'vant'
import 'vant/lib/index.css'
import getOpenid from './providers/wx-getOpenId'

Vue.use(Loading).use(Icon).use(Tabs).use(Tab).use(DropdownMenu).use(DropdownItem).use(RadioGroup).use(Radio).use(Row).use(Col).use(Cell).use(Calendar).use(Toast).use(Divider).use(ActionSheet).use(Dialog).use(Button).use(DatetimePicker).use(Popup).use(PullRefresh).use(Checkbox).use(CellGroup).use(Sticky);

Vue.prototype.$gOpenid = getOpenid;

import axios from './providers/http-service'
//定义全局变量
Vue.prototype.$Axios = axios;

import timeformat from './providers/TimeFormat'
//定义全局变量时间戳转换
Vue.prototype.$timeformat = timeformat;

import globalvalue from './providers/global'
//定义全局变量
Vue.prototype.Global = globalvalue;

Vue.config.productionTip = false

import vueWechatTitle from "vue-wechat-title"
Vue.use(vueWechatTitle);

import echarts from 'echarts'
Vue.prototype.$echarts = echarts;

import SockJS from 'sockjs-client'
Vue.prototype.$SockJS = SockJS;

import Stomp from 'stompjs'
Vue.prototype.$Stomp = Stomp;

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'OVXZdv8zGB8xVneBY2nM13h5zopneaGK'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
